import type { StageConfig } from '@capture/shared';
import { StageDeepLinks } from './StageDeepLinks';

export function ExportPanel({ config, onChange }: { config: StageConfig; onChange: (c: StageConfig) => void }) {
  const destinationIds = (config.config.destinationIds as string) ?? '';
  return (
    <div className="stage-panel">
      <label>
        Destination IDs (comma-separated)
        <input
          value={destinationIds}
          onChange={(e) => onChange({ ...config, config: { ...config.config, destinationIds: e.target.value } })}
        />
      </label>
      <StageDeepLinks stage="export" />
    </div>
  );
}
